/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const buttonGroupTokens = {
  CoreBorderRadiusDefault: '8px',
  CoreBorderRadiusCenter: '0px',
  CoreBorderRadiusHorizontalFirst: '8px 0px 0px 8px',
  CoreBorderRadiusHorizontalLast: '0px 8px 8px 0px',
  CoreBorderRadiusVerticalFirst: '8px 8px 0px 0px',
  CoreBorderRadiusVerticalLast: '0px 0px 8px 8px',
  OutlineBackgroundColor: '#ffffff',
  OutlineTextColorInitial: '#1c2222',
  OutlineTextColorHover: '#394040',
} as const;
